import * as API from "api";
import storage from "utils/storage";

const DEFAULT_IMAGE = 'data:image/png;base64,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';

/**
 * method for encoding image into base64
 * @param {String} url
 */
const getBase64FromUrl = async (url) => {
  const data = await fetch(`${url}?${Date.now()}`); //fetch image using its url
  const blob = await data.blob();
  return new Promise((resolve,reject) => {
    if(data.status === 403) {
      reject("File not found");
    }
    const reader = new FileReader();
    reader.readAsDataURL(blob); 
    reader.onloadend = function() {
      const base64data = reader.result;
      resolve(base64data.replace(/^data:binary\/octet-stream/,'data:image/png'));
    }
  });
}

/**
 * method for building resume html
 * @returns HTML as String
 */
export const buildResume = async () => {
  let data = {};
  const userId = storage.get('humlog_user'); // get userId
  try{
    const response = await API.getUser(userId); // get user information
    if(response && response.success){
      const user = response.data;
      let imageSrc = DEFAULT_IMAGE;
      if(user &&
        user.profile_pic &&
        user.profile_pic.length > 0){
          //encode user profile_Pic in base64
          await getBase64FromUrl(user.profile_pic).then((res)=>{imageSrc = res})
          .catch(error => console.log(error));
        }
      // form user data to be displayed in the pdf
      data = {
        name : user && user.name && user.name.length ? user.name : "",
        experience : user && user.experience===0
                    ? "Fresher"
                    : user && user.experience===1
                    ? "Less than 1 year"
                    : user && user.experience===2
                    ? "1-2 years"
                    : user && user.experience===3
                    ? "2-4 years"
                    : user && user.experience===4
                    ? "4-6 years"
                    : user && user.experience===5
                    ? "6-8 years"
                    : user && user.experience===6
                    ? "8-10 years"
                    : user && user.experience===7
                    ? "10+ years"
                    : "",
        about_me : `I am${user &&
                          user.about_me &&
                          user.about_me.length > 0
                            ? user.about_me.map((data) => " "+ data.label)
                            : ""}`,
        qualification:  user && parseInt(user.qualification) === 0
                        ? "below 10"
                        : user && parseInt(user.qualification) === 1
                        ? "10 th pass"
                        : user && parseInt(user.qualification) === 2
                        ? "12 th pass"
                        : user && parseInt(user.qualification) === 3
                        ? "B.A"
                        : user && parseInt(user.qualification) === 4
                        ? "B.Sc"
                        : user && parseInt(user.qualification) === 5
                        ? "B.Com"
                        : user && parseInt(user.qualification) === 6
                        ? "Other"
                        : user.qualification,
        address_home : user && user.address_home && user.address_home.length ? user.address_home : "",
        address_current : user && user.address_current && user.address_current.length ? user.address_current : "",
        email : user && user.email && user.email.length ? user.email : "",
        contact : user && user.contact && user.contact.length ? user.contact : "",
        gender : user && user.gender === 0
                ? "Female"
                : user && user.gender === 1
                ? "Male"
                : user && user.gender === 2
                ? "Others"
                : "",
        dob : user && user.dob && user.dob.length > 0
            ? new Date(user.dob).toLocaleDateString()
            : "",
        languages_known : user &&
                          user.language_known &&
                          user.language_known.length > 0
                          ? user.language_known.map((data) => " "+ data) 
                          : "",
        speak_english : user &&
                        user.speak_english &&
                        user.speak_english.length > 0
                        ? user.speak_english
                        : "",
        job_intrested : user &&
                        user.job_intrested &&
                        user.job_intrested.length > 0
                        ? user.job_intrested
                        : "",
        tech_cert : user &&
                    user.technical_cert && 
                    user.technical_cert[0] &&
                    user.technical_cert[0].cert &&
                    user.technical_cert[0].cert.length
                    ? user.technical_cert[0].cert
                    : "",
        tech_branch : user &&
                      user.technical_cert &&
                      user.technical_cert[0] && 
                      user.technical_cert[0].branch &&
                      user.technical_cert[0].branch.length
                      ? user.technical_cert[0].branch
                      : "",
        profile : imageSrc,
        video_resume : user.video_resume

      }
    }
  } catch (error) {
    console.log("error",error);
  }
 /***************** Return HTML*********************/
  const RESUME_HTML = ` <!DOCTYPE html>
  <html lang="en">
  
  <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Humlog Application</title>
    <link rel="preconnect" href="https://fonts.gstatic.com">
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@500;700&display=swap" rel="stylesheet">
    <style>
      @page  {
        margin: 0;
        size: a4; /*or width x height 150mm 50mm*/
        height: 320mm;
      }
      :root {
        --blue_color: #0678c1;
        --blue_color_hover: #0b9fe1;
        --black: #1E1F21;
        --white: #ffffff;
      }
  
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
  
      html,
      body {
        width: 100%;
        scroll-behavior: smooth;
      }
  
      body {
        font-family: 'Roboto', sans-serif;
        line-height: 1.5;
        font-size: 1rem;
        font-weight: 400;
      }
  
      h1, h2, h3, h4, h5, h6 {
        margin-bottom: .5rem;
        font-weight: 500;
        line-height: 1.2;
      }
  
      .getresume {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .container {
        height: 1080px;
        margin: 0 auto;
      }
  
      .getresume_inner {
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        height: 100%;
      }
  
      .resume_lft {
        flex: 1 1 40%;
        background-image: linear-gradient(180deg, var(--blue_color) 0%, var(--blue_color_hover) 100%);
        padding: 15px;
      }
  
      .resume_ryt {
        flex: 2 1 60%;
        padding: 15px;
        background-color: #f1f1f1;
        border-radius: 0px 4px 4px 0px;
        position: relative;
      }
  
      .r_overview,
      .r_about,
      .r_qualification,
      .r_tech_certificate,
      .r_experience,
      .r_skills {
        margin-bottom: 30px;
      }
  
      .r_profile {
        width: 180px;
        height: 180px;
        overflow: hidden;
        border: 2px solid #cccccc;
        border-radius: 50%;
        margin: 0 auto 30px;
      }
  
      .r_profile img {
        width: 180px;
        height: 180px;
      }
  
      .resume_lft h3 {
        font-size: 18px;
        color: #cccccc;
        margin-bottom: 15px;
        letter-spacing: 0.5px;
        font-weight: 600;
      }
  
      .resume_lft p {
        font-size: 16px;
        color: var(--white);
        margin-bottom: 10px;
      }
  
      .resume_lft p span {
        font-weight: 600;
        color: #cccccc;
        font-size: 14px;
      }
      .resume_lft p span.contactbox {
        position: relative;
        padding-left: 20px;
      }
      .resume_lft p span.contactbox img {
        position: absolute;
        bottom: 0;
        left: 0;
      }
  
      .resume_lft p span svg {
        margin-right: 4px;
        margin-top: -4px;
      }
  
      .resume_lft ul {
        list-style-type: square;
        padding-left: 30px;
      }
  
      .resume_lft ul li {
        font-size: 16px;
        color: var(--white);
  
      }
  
      .resume_ryt h1 {
        font-size: 34px;
        color: var(--black);
        margin-bottom: 15px;
        text-transform: capitalize;
        letter-spacing: 0.5px;
        font-weight: 500;
      }
      .resume_ryt h3 {
        font-size: 18px;
        color: var(--white);
        margin-bottom: 10px;
        letter-spacing: 0.5px;
        background-color: transparent;
        background-image: linear-gradient(270deg, #0678c1 0%, #0b9fe1 100%);
        padding: 7px;
        padding-left: 30px;
        position: relative;
      }
      .resume_ryt h3 img {
        position: absolute;
        left: 10px;
        top: 10px;
        width: 16px;
        height: 16px;
      }
      .resume_ryt p {
        font-size: 16px;
        color: var(--black);
        margin-bottom: 10px;
      }
  
      .resume_ryt ul {
        list-style-type: none;
      }
      .r_skills p {
        margin-top: 10px
      }
      .r_skills span {
        font-size: 16px;
        display: inline-block;
        padding: 5px 10px;
        border-radius: 20px;
        color: var(--black);
        background-color: #cccccc;
        margin: 5px 5px;
      }
  
      .resume_ryt ul li {
        font-size: 16px;
        display: inline-block;
        padding: 5px 10px;
        border-radius: 20px;
        color: var(--black);
        background-color: #cccccc;
        margin: 5px 5px;
      }
      .watermark {
        padding: 15px;
        position: absolute;
        bottom: 0px;
        right: 0px;
      }
      .watermark p {
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .watermark p span {
        color: var(--black);
        font-size: 16px;
        text-align: center;
      }
      .watermark img {
        width: 30px;
        margin-left: 10px;
      }
      .premium_watermark {
        background-color: #202020;
        padding: 7px;
        width: 100%;
        height: 100%;
        margin: 0 auto;
      }
  
      .premium_watermark p img {
        width: 30px;
        margin-right: 10px;
      }
  
      .premium_watermark p {
        color: var(--white);
        font-size: 16px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .video-resume img {
        padding: 15px;
        position: absolute;
        bottom: 35px;
        right: 0px;
      }
    </style>
  </head>
  
  <body>
    <section class="getresume">
      <div class="container">
        <div class="getresume_inner">
          <div class="resume_lft">
            <div class="r_profile">
              <img src="${data.profile}" class="img-fluid d-block " />
            </div>
            <div class="r_contact">
              <h3>Contact Me</h3>
              <p>
                <span class="contactbox">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFAAAA////pdmf3QAAAAJ0Uk5TAP9bkSK1AAAAOUlEQVR4nGMoYGC4wcDQ84Gh5wZDzx+GO38YbtQx5Ogx5DAwmDEwSO9h4P3HwJbMwNzIwHiYgaEOAIKSDiwJmyxsAAAAAElFTkSuQmCC" />
                </span> 
                ${data.contact}
              </p>
              <p><span>Home District: </span>${data.address_home}</p>
              <p><span>Current District: </span>${data.address_current}</p>
              <p><span>
                  <FiMail />
                </span> ${data.email}</p>
            </div>
            <div class="r_add_info">
              <h3>Additional Information</h3>
              <p><span>Language Known: </span> ${data.languages_known}</p>
              <p><span>Speak English: </span> ${data.speak_english}</p>
              <p><span>Gender: </span> ${data.gender}</p>
              <p><span>DOB: </span> ${data.dob}</p>
            </div>
            <div class="r_interest">
              <h3>Interests</h3>
              <ul>
              ${
                data.job_intrested.length > 0 &&
                data.job_intrested.map((val) => {
                  return (
                      `<li>${val.job_category}</li>`
                  );
                }).join('')}
              </ul>
            </div>
          </div>
          <div class="resume_ryt">
            <div class="r_overview">
              <h1>${data.name}</h1>
              <p>Experience ${data.experience} | Actively Looking for Job</p>
            </div>
            <div class="r_about">
              <h3>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFAAAA////pdmf3QAAAAJ0Uk5TAP9bkSK1AAAAKklEQVR4nGNgf8DA/4FBxoJBQgKKgGygCBDZ/2GokGMo4GN4wM5wgBmCAOsUCpxSa93aAAAAAElFTkSuQmCC" />
                About Me
              </h3>
              <p>${data.about_me}</p>
            </div>
            <div class="r_qualification">
              <h3>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFAAAA////pdmf3QAAAAJ0Uk5TAP9bkSK1AAAAHUlEQVR4nGNgAIO6OobjjxkONmNB//+D0ANmiEIAgB4QYr0YYDsAAAAASUVORK5CYII=" />
                Qualification
              </h3>
              <p>${data.qualification}</p>
            </div>
            <div class="r_tech_certificate">
              <h3>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAQMAAADaua+7AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFAAAA////pdmf3QAAAAJ0Uk5TAP9bkSK1AAAAN0lEQVR4nGNggIH/EMz//wMD/20gbvzAwMdQwGDHUMNgA4QWDDJgGpkNkgOpAakF6wHqhZkDBQCo/xOlV6iR3wAAAABJRU5ErkJggg==" />
                Technical Certifications
              </h3>
              <p>${data.tech_cert}</p>
              ${data.tech_branch ? `<p>Branch : ${data.tech_branch}</p>` : ``}
            </div>
            <div class="r_experience">
              <h3>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFAAAA////pdmf3QAAAAJ0Uk5TAP9bkSK1AAAAKklEQVR4nGNgYGBgf8DAlsDw/z/DAWaGBkaGD/wgdv9HEBuCgOJAETAAAE6yDVG+HlddAAAAAElFTkSuQmCC" />
                Work Experience
              </h3>
              <p>${data.experience}</p>
            </div>
            <div class="r_skills">
              <h3>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARAQMAAADuYb6HAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFAAAA////pdmf3QAAAAJ0Uk5TAP9bkSK1AAAAPElEQVR4nGOo4GOokWf4Z83wrZbh2X2Gw9sY6nMY+G4w8G5gkC5gMLvHkPuYoTqd4Vs+w596hh92DAfkAMjlEl8SGwt3AAAAAElFTkSuQmCC" />
                Skills
              </h3>
              <div>
              ${
                data.job_intrested.length > 0 &&
                data.job_intrested.map((val) => {
                  return (
                      `<p>${val.job_category}</p>${val.skills.map((skills)=>{
                        return(
                          `<span>${skills}</span>`
                        )
                      }).join('')}`
                  );
                }).join('')}
              </div>
            </div>
            ${data.video_resume && data.video_resume.length ? 
            `<div class="video-resume">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAM3SURBVFiF7ZdLaFxVGMd/37l3MoqbYlMxbbrQQjGvwdSNWjNtQFQESdriRki3ggsXrZRJTWnExkwFKcUH7oTardgsdTN5GFEhHWxJUqSoizRZxIqLPjJ35tyvi2bSed07dzIpLvS/Oo/v/P//e77z3Xsu/Nchm1m093imNe6atoJht4ijjrVLeZNfvjb+8s2HZqB7ZHYPfmFIlQGQZwPCsqoy4br+hStnDvyxJQYS780+YWP2FPA2EIvo11P0y4Lnf/jbJ/1/bdpAx/s/PG98/1vgyYjClVhR5NDCeN/PQQEmaKIzNfOm8f3JJsQB2gSd7EpNHwkKqLkDPcOTL/iYDBBvQrwUa74x/YtjL/1U18B6zn+luSevhZW8ZxOVZ6IqBesHLkRcPvfF9iB6FvAbMNAWi7kjVWylne6R2T1q7SJhpz3ubp8fffFvgK6T068CF1FaI5rwHEefKS3R8h3wC0Oh4kDu5j+3i+35j5LfOQXbC8xGNNBirQyVDpQZUJXBiEQbuPJx/9KOuD0ooh8QISUCAxX9+9h7PNMaa3FW6xHkbt165Pqnr+dqzXUMTw8a+ArYFkKhxN3WYho3diDmurvqidfD4njyklF5DsiGhIl4hfZi50EKhLZmDQBcTff9nvfsK0A+KEZ92Vlt4F/CAwPKylYQ9qRmno61ON8TUk1idLnKgDW5pWbFO4anB33ROaA3JEy1xd3Q2jCwfpkIOzyBODiacbtPTo0a+IbwCgB0rlgBZQbuW5OJRsUTJzLtqzlnUlVOV/IFoEyjbIHr+hcAL2x1fPu2x4rtrtTMa9Z1ssD+iH5zVv2LpQNVX8PO4anzgrwbSCH6hRT4TB1zFPQEjVSScm4+nTxWOlS1OI6cgZCKUHlHHVkATTUkjt6w4o1VjlYRZMeTq0blDeBOdPK6WMPI4Vq35ppPcDXdN4dyFFjbAvG7ovLW/Fjyl1qToZfSztRUr4hMALs3Kb6M4VCQONTJ4UL6QDbv2X2onKdOdVQgh3LO4iXCxKGBH5PEyNRT1sqQwIDCvgCyy6pcstivr6X7/4zCu6lfs67RHx83d/O7rOO0AzjWLvmPxm6UvuH+R1TcA06SImq2niioAAAAAElFTkSuQmCC" />
            </div>` : ``}
            <div class="watermark">
              <p>
                <span>Humlogjobs - Humara Job Portal</span>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAotQTFRFAAAADn/FCX3FB33FB37GBn/HBoDIBoHIBoLJBoPKBoXLBobNB4jOCInPCIrQCIvRCI3SCI3TCI/TCJDWCJHWCJPXCJXZCZbaCZfbCpnbC5rcDJveEJ/fD37ECHvDBnvEBnzFBn7GB4HJCprcCpvdC5zfEJ/gCXrCBnnCCpzfC57fB3nBCp3fB3nBGIK8VYGOVoOOGYa+B3nCGYC7sHpK73wY8IEXuodBF4jCCZDUYrnlodXwhcrsJKHdYHuF7nYa8YcVUomUZ7rk////w+X2FpzcbHt873YaXomLuuDz+/3+M6jgw+T1N6rhaXt/WomNOn6i4Xck6ocbMoitpdbw7/j9K6XfTn+Txn04yII2VIaQCIjNIZvZv+L03/H61u35Y7znCpfaB4DIB4PKH4O4T4OTV4aOWImOWYyPWo+PWpGPWpSPW5eQW5qQXZ2QZKOSYqWRXKWRXaiRIpzGHYC4lXtd6Xwc8YEX8o0U85IT9JcS9Z4Q9qMP96kO+K4M+bQL+rkK+78J/MQI/ckHN6GzHH+3unVCt7pEDJjZlnRc7XEb75cW0ZsuwZ47waM7wac6wqw6wrA5uLNBb6mEFJnSInyz6Wwe1JEtQ42gDYzNXLXjfcXpfcbqhsrswOT1LKbfB33GdnR05WwhxXQ55IwfJoq3/v//MajgFny6mHFbT3mRaXt+g4ptZ3uAW4mNWImPZHuC8YcWVYmRtt7y+/3/MKfgLH+t1Hcu34cjJoi2uOH0FZzbB3nBB4HIPIChoX9UooJTP4agDJHVaLvmtt/zkM/tKKPdB3nBCI/UCJHVCJLXCJXYCHnCBoPLC57fDX3EB3rDCpzfDZ7fDH3EB3zEB4TLC5vdDZ3fEp/gtt+yiQAAANl0Uk5TAAdy2/3////////////////////////////sohwHqP///////98ncf//ytv//P///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+v/////oP/pG975WiXI/+hZAsD5j88AAAGGSURBVHicY2BgZGJmYWVj5+Dk4ubh5eMXEBQSFhEVE5eQlJKWYWCQlZNXUGRlU8KUVlZRVWNQ18AtranFoI1PWodBFyqtp29giEXaCCJtbGJqZm4Blra0sraxRZO2szc1c3AESzs5Ozu7uKJKu7kDpT3A0p5AaS9vnNI+QGlnX1RpP5C0P07pgEBTs6BgsHQIUDY0DFVaKTwiMioaLB0TGxefkIginaSUnJKalp6RmZWdk5uXX1BYVIyiu6S0rNyhorKquqa2rr6hsam5BVm6tQ3kNCTp9g5k6c4uiHR3T29f/4SJkyZPQbZ76jSgNNDw6TNmCgjOmj1n7rz5SNILFi5aDNK9ZCks1JYtR5JesXLVapD0Gl6s0kCXrwVJr8MvvZ4C6XLc0kkbgLo3bgJLbwZKb9mKqnvbdlOzHTvB0rOWOTvv2g2V3gOR3rtv/4GDkBg7dPjI0WOwtHYcGqHJ8IR84uQp0dMw6TMw6bNYpM8xnL+AW/riJQaGy1cg0lcxpK9dvwEAKaLJSXL3WpoAAAAASUVORK5CYII=" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </body>
  
  </html>`
  return RESUME_HTML;
}
